import { createSlice } from "@reduxjs/toolkit";

const initialState = { value: "" };

export const extraLessonTaskSlice = createSlice({
  name: "lessonTask",
  initialState,
  reducers: {
    extraLessonTaskReducer: (state, action) => {
      state.value = action.payload;
    },
  },
});
export const { extraLessonTaskReducer } = extraLessonTaskSlice.actions;
export default extraLessonTaskSlice.reducer;
